import { NPC } from './../../lib/interfaces';
import parse from 'html-react-parser';

interface NPCProps {
    data: Array<NPC>;
}

export default function NPCs({ data }: NPCProps) {
    return <div className="panel">
        {data.map(npc => <>
            <h2>{npc.name}</h2>
            <h3>{npc.title}</h3>
            <b>{npc.stats}</b>
            <p>{parse(npc.description)}</p>
        </>)}
    </div>;
}
